import { useCallback, useEffect, useState } from 'react';
import kkpService from '../services/kkpService';

const EMPTY_CATALOG = { mag: {}, set: {} };

export const useKkpPublications = () => {
  const [catalog, setCatalog] = useState(EMPTY_CATALOG);

  useEffect(() => {
    let cancelled = false;
    kkpService.listPublications()
      .then((data) => {
        if (!cancelled) {
          setCatalog({
            mag: data?.mag ?? {},
            set: data?.set ?? {},
          });
        }
      })
      .catch(() => {
        if (!cancelled) setCatalog(EMPTY_CATALOG);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const getPublicationUrl = useCallback((type, annee, mois, fallbackUrl) => {
    if (fallbackUrl) return fallbackUrl;
    if (!annee || !mois) return null;
    const key = `${annee}-${String(Number(mois)).padStart(2, '0')}`;
    return catalog[type]?.[key] || null;
  }, [catalog]);

  return { getPublicationUrl };
};
